import * as React from 'react';
import { Fragment } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Form } from 'react-final-form';
import { required, minLength, maxLength, minValue, maxValue, number, regex, email, choices, DateTimeInput, DateInput } from 'react-admin';
import {
    useListContext,
    useRedirect,
    List,
    Datagrid,
    Filter,
    Edit,
    Create,

    Toolbar,
    TopToolbar,
    DeleteWithConfirmButton,
    BulkDeleteWithConfirmButton,
    Show,
    SimpleShowLayout,

    ReferenceField,
    TextField,
    ImageField,
    BooleanField,
    RichTextField,

    SimpleForm,
    ReferenceInput,
    SelectInput,
    TextInput,
    NumberInput,
    BooleanInput,
    NullableBooleanInput,

    Button,
    EditButton,
    ShowButton,
    SaveButton,
} from 'react-admin';
import RichTextInput from 'ra-input-rich-text';
import { Button as CButton, Box } from '@material-ui/core';
import { ArrowBack, Search } from '@material-ui/icons';

const useStyles = makeStyles({
    imageField: {
        '& img': { width: 60 }
    },
});

const useTxtData = {
    page: {
        tableName: '政策信息',
    },
    table: {
        id: 'ID',
        Title: '标题',
        Content: '正文',
        Type: '分类',
        Region: '地域',
        PublishTime: '发布时间',
    }
};

export const PolicyInfoList = (props) => {
    const Filters = (props) => {
        const { displayedFilters, filterValues, setFilters, hideFilter, } = useListContext();
        if (props.context === "button") return null;
        const onSubmit = values => { if (Object.keys(values).length > 0) { setFilters(values); } else { setFilters({}, []); } };
        const resetFilter = () => { setFilters({}, []); };
        return (
            <div>
                <Form onSubmit={onSubmit} initialValues={filterValues}>
                    {({ handleSubmit }) => (
                        <form onSubmit={handleSubmit}>
                            <Box display='flex' alignItems='center'>
                                <Box component="span" mr={2}>
                                    <TextInput label="关键词" source="key" alwaysOn resettable />
                                </Box>
                                <Box component="span" mr={2} mb={2.5}>
                                    <CButton variant="contained" color="primary" type="submit" startIcon={<Search />}>搜索</CButton>
                                </Box>
                                <Box component="span" mr={2} mb={2.5}>
                                    <CButton variant="outlined" onClick={resetFilter}>重置</CButton>
                                </Box>
                            </Box>
                        </form>
                    )}
                </Form>
            </div>
        );
    };

    const AssetBulkActionButtons = (props) => {
        return (
            <Fragment>
                <BulkDeleteWithConfirmButton {...props} confirmTitle="删除确认" confirmContent="确认要删除所选记录吗？" />
            </Fragment>
        );
    };

    const RowAction = (props) => {
        return (
            <div style={{ textAlign: 'right' }}>
                <EditButton {...props} /><br />
                <ShowButton {...props} /><br />
                <DeleteWithConfirmButton {...props} confirmTitle="删除确认" confirmContent="确认要删除该记录吗？" />
            </div>
        );
    }

    return (
        <List {...props} title={useTxtData.page.tableName + '列表'} sort={{ field: 'id', order: 'DESC' }} filters={<Filters />} bulkActionButtons={<AssetBulkActionButtons />} >
            <Datagrid>
                <TextField label={useTxtData.table.id} source="id" />
                <TextField label={useTxtData.table.Title} source="Title" />
                <TextField label={useTxtData.table.Type} source="Type" />
                <TextField label={useTxtData.table.Region} source="Region" />
                <TextField label={useTxtData.table.PublishTime} source="PublishTime" />
                <RowAction />
            </Datagrid>
        </List>
    );
};

export const PolicyInfoShow = (props) => {
    const ShowActions = (props) => {
        const { basePath, data } = props; const redirect = useRedirect();
        return (
            <TopToolbar>
                <Button label="返回列表" onClick={() => redirect(basePath)} variant="text">
                    <ArrowBack />
                </Button>
                <EditButton basePath={basePath} record={data} />
            </TopToolbar>
        );
    };

    return (
        <Show title={'查看' + useTxtData.page.tableName} {...props} actions={<ShowActions />}>
            <SimpleShowLayout>
                <TextField label={useTxtData.table.id} source="id" />
                <TextField label={useTxtData.table.Title} source="Title" />
                <TextField label={useTxtData.table.Type} source="Type" />
                <TextField label={useTxtData.table.Region} source="Region" />
                <TextField label={useTxtData.table.PublishTime} source="PublishTime" />
                <RichTextField label={useTxtData.table.Content} source="Content" />
            </SimpleShowLayout>
        </Show>
    );
}

export const PolicyInfoEdit = (props) => {
    const PostEditActions = (props) => {
        const { basePath } = props; const redirect = useRedirect();
        return (
            <TopToolbar {...props}>
                <Button label="返回列表" onClick={() => redirect(basePath)} variant="text">
                    <ArrowBack />
                </Button>
            </TopToolbar>
        );
    };
    const PostEditToolbar = (props) => {
        return (
            <Toolbar {...props}>
                <SaveButton />
            </Toolbar>
        );
    };
    return (
        <Edit title={'编辑' + useTxtData.page.tableName} undoable={false} {...props} actions={<PostEditActions />}>
            <MyForm Edit={true} toolbar={<PostEditToolbar />} />
        </Edit>
    );
};

export const PolicyInfoCreate = (props) => {
    const PostCreateActions = (props) => {
        const { basePath } = props; const redirect = useRedirect();
        return (
            <TopToolbar {...props}>
                <Button label="返回列表" onClick={() => redirect(basePath)} variant="text" >
                    <ArrowBack />
                </Button>
            </TopToolbar>
        );
    };
    const PostCreateToolbar = (props) => {
        const { basePath } = props;
        return (
            <Toolbar {...props}>
                <SaveButton label="保存&列表" redirect={basePath} submitOnEnter={true} />
                <SaveButton label="保存&继续" redirect={false} submitOnEnter={false} variant="text" />
            </Toolbar>
        );
    };

    return (
        <Create title={'新增' + useTxtData.page.tableName} undoable={false} {...props} actions={<PostCreateActions />}>
            <MyForm Create={true} toolbar={<PostCreateToolbar />} />
        </Create>
    );
};

const MyForm = (props) => {
    return (
        <SimpleForm {...props} >
            <TextInput label={useTxtData.table.Title} source="Title" validate={[required()]} fullWidth />
            <TextInput label={useTxtData.table.Type} source="Type" />
            <TextInput label={useTxtData.table.Region} source="Region" />
            <DateInput label={useTxtData.table.PublishTime} source="PublishTime" validate={[required()]} />
            <RichTextInput label={useTxtData.table.Content} source="Content" validate={[required()]} />
        </SimpleForm>
    );
}
